import React from 'react';
import { useNavigate } from 'react-router-dom';
import MAvatar from './MAvatar';
import MOptionsMenu from './MOptionsMenu';
import { IconEdit, IconCircleX } from '@tabler/icons-react';
import styles from './NoteCard.module.css';

export interface NoteCardProps {
  noteId: string;
  title: string;
  meta: string;
  avatar?: {
    src?: string;
    text: string;
    alt: string;
  };
  onEdit?: () => void;
  onDelete?: () => void;
}

const NoteCard: React.FC<NoteCardProps> = ({
  noteId,
  title,
  meta,
  avatar,
  onEdit,
  onDelete,
}) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/profile/family/notes/detail?noteId=${noteId}`);
  };

  const options = [
    {
      id: 'edit',
      label: 'Edit',
      icon: <IconEdit size={16} />,
      onClick: () => onEdit?.(),
    },
    {
      id: 'delete',
      label: 'Delete',
      icon: <IconCircleX size={16} />,
      onClick: () => onDelete?.(),
      destructive: true,
      className: 'delete',
    },
  ];

  return (
    <button 
      className={styles.noteCard} 
      onClick={handleCardClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleCardClick();
        }
      }}
    >
      <div className={styles.content}>
        {/* Avatar on the left */}
        <div className={styles.avatarContainer}>
          {avatar && (
            <MAvatar
              size={24}
              type={avatar.src ? 'dp' : 'no-dp'}
              src={avatar.src}
              text={avatar.text}
              alt={avatar.alt}
              showBadge={false}
              textSize={11}
            />
          )}
        </div>

        {/* Text content */}
        <div className={styles.textContainer}>
          <div className={styles.title}>{title}</div>
          <div className={styles.meta}>{meta}</div>
        </div>

        {/* Options menu (3 dots) */}
        <div className={styles.optionsContainer}>
          <div onClick={(e) => e.stopPropagation()}>
            <MOptionsMenu options={options} />
          </div>
        </div>
      </div>
    </button>
  );
};

export default NoteCard;
